export default {"src":"/_next/static/media/indpackage.e61ce8bf.svg","height":16,"width":16};